import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import './TVBook.css';
import './TVBookShelf.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBookAtlas, faGifts, faUserFriends, faUserPlus, faUserTie, faUsers } from '@fortawesome/free-solid-svg-icons';
import TVBookShelf from './TVBookShelf';
import tvbookimage from '../../assets/pageimages/TVBook.webp';


function TVBookHome() {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [bookId, setBookId] = useState(null);

  const [isMyBooksHovered, setIsMyBooksHovered] = useState(false);

  const handleMyBooksMouseEnter = () => {
      setIsMyBooksHovered(true);
  };

  const handleMyBooksMouseLeave = () => {
      setIsMyBooksHovered(false);
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Example: Set to true if width is <= 768px (mobile/tablet breakpoint)
    };

    handleResize(); // Run initially to check the screen size
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (isMobile) {
    return (
      <div className="flex flex-col items-center justify-center h-screen p-4 text-center bg-gray-100">
        <div className="bg-white p-6 rounded-lg shadow-lg mb-8">
          <h2 className="text-2xl font-bold text-red-600 mb-4">
            This Page is not available on Small Devices such as Mobile / Tablet.
          </h2>
          <p className="text-lg text-gray-700">
            View this on a Smart TV, Laptop, or Desktop!
          </p>
        </div>
        <div className="flex justify-center">
          <Link 
            to='/dashboard' 
            className='flex items-center justify-center px-4 py-4 text-xl font-semibold text-white bg-blue-600'
          >
            <FontAwesomeIcon icon={faBookAtlas} />  
            Go to Dashboard
          </Link>
        </div>
      </div>
    );
  }
  

  return (
    <div>
      <div className="image-container">
          <div className="relative mt-4 w-full">
              <img id="tvbook-id" src={tvbookimage} alt="My TV Book Image" className="border border-b-gray-300" />
              <h1 className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-blue-700 text-4xl flex justify-center">
                  {userName}'s TV Book <br/>
                  on Think5Whys
              </h1>
          </div>
      </div>
      <div className="flex justify-center mt-8">
          <Link 
              to='/dashboard' 
              className='flex items-center justify-center w-4/5 sm:w-2/4 h-12 sm:h-16 text-lg sm:text-2xl font-semibold text-white bg-blue-600 rounded-lg shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring focus:ring-blue-500'
          >
              <FontAwesomeIcon className="mr-2 sm:mr-4" icon={faBookAtlas} />  
              Go to Dashboard
          </Link>
      </div>
      <div className="flex justify-center mt-8">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <TVBookShelf />
        </div>
      </div>
    </div>
  );
}

export default TVBookHome;
